import axios from "axios";
import { apiRoot, auth } from "../index";
import { startLoading, stopLoading } from "./loader";

export async function deleteAccount(jwt) {
  try {
    startLoading();

    await axios.post(
      `${apiRoot}/api/v1/delete-account`,
      {},
      {
        headers: {
          Authorization: jwt,
        },
      }
    );

    stopLoading();

    await auth.signOut();
  } catch (e) {
    stopLoading();
    console.error(e);
  }
}

export async function registerTotp(jwt) {
  try {
    startLoading();
    const res = await axios.post(
      `${apiRoot}/api/v1/auth/register-totp`,
      {},
      {
        headers: {
          Authorization: jwt,
        },
      }
    );

    stopLoading();
    return res.data;
  } catch (e) {
    stopLoading();
    console.error(e);
  }
}

export async function disableTotp(jwt) {
  try {
    startLoading();
    await axios.post(
      `${apiRoot}/api/v1/auth/disable-totp`,
      {},
      {
        headers: {
          Authorization: jwt,
        },
      }
    );

    stopLoading();
  } catch (e) {
    stopLoading();
    console.error(e);
  }
}

export async function verifyTotp(jwt, code) {
  try {
    startLoading();

    const res = await axios.post(
      `${apiRoot}/api/v1/auth/verify-totp`,
      {
        code,
      },
      {
        headers: {
          Authorization: jwt,
        },
      }
    );

    stopLoading();

    if (res.data?.success) {
      localStorage.setItem("totpJwt", res.data.jwt);
      return true;
    }
  } catch (e) {
    stopLoading();
    console.error(e);
  }

  return false;
}

export async function isTotpValidated(jwt) {
  try {
    startLoading();
    const res = await axios.post(`${apiRoot}/api/v1/auth/is-totp-validated`, {}, {
      headers: {
        Authorization: jwt,
      },
    });

    stopLoading();
    return res.data === true;
  } catch (e) {
    stopLoading();
    console.error(e);
    return false;
  }
}
export async function isTotpEnabled(jwt) {
  try {
    startLoading();
    const res = await axios.post(`${apiRoot}/api/v1/auth/is-totp-enabled`, {}, {
      headers: {
        Authorization: jwt,
      },
    });

    stopLoading();
    return res.data === true;
  } catch (e) {
    stopLoading();
    console.error(e);
    return false;
  }
}
